import { render } from "./DraggableList.vue?vue&type=template&id=de8b7a10&scoped=true"
import script from "./DraggableList.vue?vue&type=script&lang=js"
export * from "./DraggableList.vue?vue&type=script&lang=js"

import "./DraggableList.vue?vue&type=style&index=0&id=de8b7a10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de8b7a10"]])

export default __exports__